import script from "./AccessNavbar.vue?vue&type=script&setup=true&lang=ts"
export * from "./AccessNavbar.vue?vue&type=script&setup=true&lang=ts"

import "./AccessNavbar.vue?vue&type=style&index=0&id=7434c0fb&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7434c0fb"]])

export default __exports__